





























































































































































import { Component, Vue } from "vue-property-decorator";
import Country from "@/store/entities/country";
import City from "@/store/entities/city";
import Airport from "@/store/entities/flight/airport";
@Component({})
export default class AddAirport extends Vue {
  dialog: boolean = true;
  countries: Country[] = [];
  country: Country = new Country();
  cities: City[] = [];
  selectedCity: City = new City();
  airport: Airport = new Airport();
  isEdit: boolean = false;
  isValid: boolean = false;

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
        dropdown: (value) => !!value.id || "Zorunlu Alan.",
      },
    };
  }

  async created() {
    await this.getCountries();

    this.airport = this.$store.state.airport.editAirport;
    if (this.airport == null) {
      this.isEdit = false;
      this.airport = new Airport();
    } else {
      this.isEdit = true;
      let countryId = this.airport.countryId;
      this.country = this.countries.find((x) => x.id == this.airport.countryId);
      this.getCities().then((x) => {
        this.selectedCity = this.cities.find(
          (x) => x.id == this.airport.cityId
        );
      });
    }
  }

  async saveAirport() {
    this.airport.countryId = this.country.id;
    this.airport.cityId = this.selectedCity.id;

    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "airport/saveAirport",
        data: this.airport,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "airport/saveAirport",
        data: this.airport,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  async getCountries() {
    await this.$store.dispatch({
      type: "country/getCountries",
    });
    this.countries = this.$store.state.country.list;
  }

  async getCities() {
    await this.$store.dispatch({
      type: "city/getCities",
      data: this.country.id,
    });
    this.cities = this.$store.state.city.list;
  }

  closeDialog() {
    this.$emit("closed");
    this.$store.state.airport.editAirport = null;
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.airport.editAirport = null;
  }
}
